module.exports = __webpack_public_path__ + "img/trd.d9a7111e.svg";